const QUERY = gql`
  query GrowerProductEmailQuery($slug: String!) {
    workOrder: growerProduct(slug: $slug) {
      id
      slug
      grower {
        id
        name
      }
      growerContact {
        id
        name
        email
      }
      fieldTicketId
      submittedAt
      shipment {
        id
        shipDate
        deliveryDate
        freightCompany {
          id
          name
        }
        terms
      }
      customFields
    }
  }
`;

export default { QUERY };
